export const VERSION_NUMBER = '1.1.0';

// 1x00000000000000000000AA ALWAYS PASSES
// 2x00000000000000000000AB FAILS
// 3x00000000000000000000FF FORCES INTERACTIVE CHALLENGE
export const CLOUDFLARE_TURNSTILE_SITE_KEY = window.location.origin.includes(
  'localhost',
)
  ? '1x00000000000000000000AA'
  : '0x4AAAAAAA9MxUxefgHBoNjc';

export const CLIENT_URL_LOCALHOST = 'http://localhost:3000/app/#';
export const CLIENT_URL_DEV =
  'https://marshopping-campaignmanager-20099437021.development.catalystserverless.eu/app/#/';
export const CLIENT_URL_PROD = 'https://campanhas.marshopping.com/app/#/';

export const CLIENT_URL = window.location.origin.includes('localhost')
  ? CLIENT_URL_LOCALHOST
  : window.location.origin.includes('campanhas.marshopping.com')
    ? CLIENT_URL_PROD
    : CLIENT_URL_DEV;

// CATALYST
export const CATALYST_API_FUNCTION_ID = 'advancedio-api';

export const CATALYST_USER_ROLES = {
  admin: 'Administrador',
  user_admin: 'Operador Admin',
  user: 'Operador',
  tablet: 'Tablet de Consentimentos',
  customer: 'Cliente',
};

export const CATALYST_BACKOFFICEUSER_ROLES = {
  admin: 'Administrador',
  user_admin: 'Operador Admin',
  user: 'Operador',
  tabletConsents: 'Tablet de Consentimentos',
};

// CAMPAIGNS
export const CAMPAIGN_STATES = {
  YET_TO_START: 'Por Começar',
  ONGOING: 'Em Curso',
  POST_END_DATE: 'Estabilização (pós data de fecho)',
  READY_TO_DRAW: 'Pronta para Sortear',
  DRAW_CONCLUDED: 'Sorteio Concluído',
  CONCLUDED: 'Concluída',
};

export const CAMPAIGN_COLORS = {
  [CAMPAIGN_STATES.ONGOING]: 'bg-green-600 hover:bg-green-600/80',
  [CAMPAIGN_STATES.POST_END_DATE]: 'bg-orange-600 hover:bg-orange-600/80',
  [CAMPAIGN_STATES.READY_TO_DRAW]: 'bg-red-600 hover:bg-red-600/80',
  [CAMPAIGN_STATES.DRAW_CONCLUDED]: 'bg-green-800 hover:bg-red-800/80',
  [CAMPAIGN_STATES.CONCLUDED]:
    'bg-stone-600 hover:bg-stone-600/80 dark:bg-stone-400 dark:hover:bg-stone-400/80',
};

export const CAMPAIGN_GENERATE_WINNERS_STATES = {
  ONGOING: 'Em Curso',
  CONCLUDED: 'Gerado(s) com Sucesso',
  ERROR: 'Erro ao Gerar',
};

export const CAMPAIGN_BANNER_DIMENSIONS = { width: '600', height: '900' };
export const CAMPAIGN_INACTIVE_HERO_SM_DIMENSIONS = {
  width: '1080',
  height: '1920',
};
export const CAMPAIGN_INACTIVE_HERO_XL_DIMENSIONS = {
  width: '1920',
  height: '1080',
};

// TOOD
export const CAMPAIGN_TERMS_OF_PARTICIPATION =
  'Declaro que li e tomei conhecimento do tratamento dos dados pessoais por mim fornecidos, nos termos definidos na cláusula 13.º do Regulamento do Concurso Publicitário “A magia deste Natal leva-o mais longe”, Concurso Publicitário com a Licença n.º 05/2025, autorizado pela Câmara Municipal de Matosinhos em 09 de novembro de 2025 – “Prémios não convertíveis em dinheiro” – promovido pela Ingka Centres Portugal, S.A., p.c. 507 161 025., no âmbito da minha participação no mesmo concurso.';
export const CAMPAIGN_TERMS_OF_DATA_SHARING =
  'Autorizo o tratamento dos dados pessoais, por mim fornecidos à Ingka Centres Portugal, para efeitos de marketing e outras mensagens comerciais.';
export const CAMPAIGN_TERMS_OF_DATA_SHARING_LIVLI_FAMILY =
  'Quero tornar-me membro do programa de vantagens Livli Family e usufruir dos descontos e benefícios exclusivos associados, autorizando para o efeito o tratamento dos meus dados pessoais pela Ingka Centres Portugal';

// INVOICES
export const INVOICES_STATES = {
  PENDING: 'Pendente',
  APPROVED: 'Aprovada',
  REJECTED: 'Rejeitada',
  VOIDED: 'Anulada',
};

// COUPONS
export const COUPONS_STATES = {
  VALID: 'Válido',
  VOIDED: 'Anulado',
};

// MISC
export const TABLE_FILTER_LIKE = {
  RIGHT: 'like*',
  LEFT: '*like',
  BOTH: '*like*',
  IN: 'in',
};

export const DISTRICTS = [
  'Aveiro',
  'Beja',
  'Braga',
  'Bragança',
  'Castelo Branco',
  'Coimbra',
  'Évora',
  'Faro',
  'Guarda',
  'Leiria',
  'Lisboa',
  'Portalegre',
  'Porto',
  'Região Autónoma da Madeira',
  'Região Autónoma dos Açores',
  'Santarém',
  'Setúbal',
  'Viana do Castelo',
  'Vila Real',
  'Viseu',
];

// DATES
export const DATE_FORMAT = 'dd-MM-yyyy';
export const DATETIME_FORMAT = 'dd-MM-yyyy HH:mm:ss';
export const DATETIME_FORMAT_STANDARD = 'yyyy-MM-dd HH:mm:ss';

export const MAX_FILE_SIZE = 15000000;
